module.exports = __webpack_public_path__ + "static/media/italy_tapeguy.8d1e87be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/italy_tapeguy.jpg
// module id = 450
// module chunks = 0